import React from 'react';

import "./Page.css"

const Page = (props) => (
	<div className={"print-page"}>
		<div className={"print-page-content"}>
			{props.children}
		</div>
		<div className={"print-page-footer"}>
			<div className={"print-footer-copyright"}>Privileged and Confidential   &#169; SAR, LLC. {new Date().getFullYear()}</div>
		</div>
	</div>
);


export default Page;



// WEBPACK FOOTER //
// ./src/common/components/PrintReport/Page.js